import { useNotes } from 'app/agriculture/queries/notes/useNotes';
import { useMemo } from 'react';
import Fuse from 'fuse.js';
import { useUsers } from 'app/agriculture/hooks/users/useUsers';
import { useGenericEntityFromId } from 'app/agriculture/queries/entities/useGenericEntityFromId';

export function useNoteResults(textFilter: string) {
    const notes = useNotes();
    const users = useUsers();
    const getParent = useGenericEntityFromId();

    const fuse = useMemo(
        () =>
            new Fuse(Array.from(notes.values()), {
                keys: [
                    'text',
                    {
                        name: 'parent.name',
                        weight: 0.4,
                        getFn: ({ parentId }) => getParent(parentId)?.name ?? 'The Farm',
                    },
                    {
                        name: 'parent.type',
                        weight: 0.2,
                        getFn: ({ parentId }) => getParent(parentId)?.type ?? '',
                    },
                    {
                        name: 'creator.name',
                        weight: 0.2,
                        getFn: ({ creatorId }) =>
                            users.find((user) => user.id === creatorId)?.name ?? '',
                    },
                ],
            }),
        [notes, getParent, users],
    );

    return useMemo(
        () =>
            !textFilter
                ? Array.from(notes.values())
                : fuse.search(textFilter).map(({ item }) => item),
        [textFilter, fuse, notes],
    );
}
